import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingClearBackgroundConfig } from '@/data/landingConfig/landingClearBackgroundConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_ClearBackground } from './schemaObject';

interface Props {}
const ClearBackground: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_ClearBackground} />
			<LandingTemplate
				data={landingClearBackgroundConfig}
				funnelLinkService={GenerateLandingLinkService.funnelRemoveBGV3()}
			/>
		</>
	);
};

export default ClearBackground;
